import React from "react";

const Navbar = () => {
  return (
    <header
      style={{
        background:
          "linear-gradient(266.47deg, #000000 58.6%, #666666 131.89%)",
      }}
    >
      <nav
        aria-label="Global"
        className="mx-auto grid max-w-7xl grid-cols-1 items-center justify-between p-4 lg:flex lg:px-4"
      >
        <div className="flex justify-between lg:block">
          <span className="sr-only">Your Company</span>
          <a href="https://www.prestigeride.com/">
            <svg
              width="300"
              height="25"
              viewBox="0 0 300 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M41.461 24.3621L36.9822 16.7658H30.1436V24.3621H24.5709V0.983703H38.5872C40.2506 0.983703 41.6861 1.32947 42.8938 2.00493C44.1175 2.68039 45.0551 3.61585 45.7225 4.8113C46.3767 5.99067 46.7184 7.35767 46.7184 8.88281C46.7184 10.4937 46.3344 11.9197 45.553 13.1554C44.7849 14.3937 43.8182 15.2836 42.6528 15.8304L47.8414 24.3621H41.4583H41.461ZM40.4227 11.011C40.9048 10.5071 41.1484 9.80219 41.1484 8.88281C41.1484 7.96344 40.8783 7.24241 40.3671 6.7385C39.8559 6.25067 39.2573 5.99067 38.5899 5.99067H30.1462V11.7589H38.5899C39.3288 11.7589 39.9407 11.4989 40.4227 11.011Z"
                fill="white"
              />
              <path
                d="M52.3387 0.983703H72.9367V5.99067H57.9113V10.1774H65.5843V15.1844H57.9113V19.3578H72.9367V24.3647H52.3387V0.983703Z"
                fill="white"
              />
              <path
                d="M84.172 24.3621C82.7074 23.9439 81.4149 23.4132 80.3051 22.7351C79.1821 22.0596 78.2286 21.2528 77.434 20.3174L80.9302 16.4174C81.4414 16.9937 82.0664 17.5244 82.7921 18.0444C83.5178 18.5644 84.3998 19.0093 85.4354 19.398C86.4578 19.7866 87.6258 19.9877 88.9183 19.9877C90.142 19.9877 91.2358 19.8 92.2026 19.4275C93.156 19.0683 93.9082 18.6502 94.4353 18.1623C94.9624 17.6745 95.2325 17.2564 95.2325 16.8972C95.2325 16.479 95.0048 16.1628 94.5651 15.9483C94.1254 15.7339 93.4845 15.5731 92.6449 15.4739C91.8053 15.372 90.8677 15.2863 89.8162 15.23C88.8071 15.1737 87.7688 15.1013 86.7041 14.9861C85.6394 14.8708 84.6011 14.6832 83.592 14.4259C82.5961 14.1659 81.6877 13.7772 80.8613 13.2599C80.0376 12.7426 79.3834 12.051 78.8987 11.1745C78.4008 10.3115 78.1598 9.21786 78.1598 7.89375C78.1598 6.56964 78.5994 5.34738 79.4814 4.19749C80.3634 3.0476 81.6003 2.12555 83.2053 1.42061C84.8262 0.715664 86.7306 0.356492 88.9474 0.356492C90.6399 0.356492 92.1602 0.544119 93.4818 0.916694C94.8035 1.30535 95.9688 1.79318 96.9515 2.41235C97.9473 3.01544 98.8426 3.76595 99.6663 4.64244L96.1119 8.23952C95.4577 7.63643 94.8194 7.14592 94.1916 6.74386C93.5798 6.3418 92.87 6.00944 92.0463 5.76552C91.2226 5.50552 90.2267 5.39027 89.0322 5.39027C87.5252 5.39027 86.1744 5.66366 85.009 6.22387C83.8277 6.78407 83.245 7.34695 83.245 7.89375C83.245 8.38158 83.502 8.77024 83.9972 9.04364C84.5084 9.31704 85.2341 9.53147 86.1585 9.67621C87.0828 9.82095 88.1211 9.93621 89.2573 10.0354C90.5075 10.1506 91.7867 10.2954 93.066 10.4964C94.3585 10.6974 95.553 11.0137 96.6628 11.4613C97.7725 11.9063 98.681 12.5684 99.3935 13.4314C100.103 14.2945 100.445 15.4444 100.445 16.8999C100.445 18.3553 99.9894 19.6473 99.0809 20.8856C98.1566 22.1239 96.8482 23.1157 95.1292 23.8769C93.4103 24.6247 91.3471 25 88.9448 25C87.2259 25 85.6314 24.7829 84.1694 24.3674L84.172 24.3621Z"
                fill="white"
              />
              <path
                d="M114.954 24.3621V5.99067H104.945V0.983703H130.549V5.99067H120.527V24.3621H114.954Z"
                fill="white"
              />
              <path
                d="M135.046 24.3621V5.89418H140.619V24.3621H135.046Z"
                fill="white"
              />
              <path
                d="M152.108 23.3971C149.918 22.333 148.212 20.8642 146.975 19.0093C145.738 17.1384 145.113 15.0397 145.113 12.6782C145.113 10.3168 145.738 8.20468 146.975 6.34716C148.212 4.47625 149.918 3.02348 152.108 1.95937C154.299 0.879168 156.828 0.348451 159.699 0.348451C161.577 0.348451 163.537 0.766592 165.613 1.58679C167.69 2.40699 169.366 3.53007 170.659 4.92388L167.007 9.02487C166.167 8.03313 165.073 7.22633 163.693 6.63665C162.313 6.03356 160.864 5.74408 159.357 5.74408C157.681 5.74408 156.2 6.01748 154.895 6.57768C153.586 7.12448 152.548 7.91519 151.809 8.9525C151.057 9.98713 150.686 11.2255 150.686 12.6782C150.686 14.131 151.083 15.3533 151.867 16.3906C152.649 17.4252 153.687 18.2186 155.008 18.7788C156.317 19.3256 157.766 19.599 159.357 19.599C160.806 19.599 162.173 19.3122 163.423 18.7225C164.673 18.1194 165.555 17.4145 166.082 16.5782H158.618V11.5712H171.967V24.3621H166.395V23.239C164.718 24.405 162.485 24.9946 159.699 24.9946C156.913 24.9946 154.296 24.4612 152.108 23.3971Z"
                fill="white"
              />
              <path
                d="M176.462 0.983703H197.06V5.99067H182.035V10.1774H189.708V15.1844H182.035V19.3578H197.06V24.3647H176.462V0.983703Z"
                fill="white"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.0763 8.6255C20.0763 9.51807 19.9121 10.3785 19.6048 11.1745C18.4606 14.1444 15.3777 16.2726 11.7491 16.2726H5.55143V24.2039H0V11.1745H11.7491C13.2827 11.1745 14.5248 10.0354 14.5248 8.6255C14.5248 7.21561 13.2827 6.07645 11.7491 6.07645H8.32715V0.983703H11.7491C15.3777 0.983703 18.4606 3.10925 19.6048 6.07645C19.9094 6.87788 20.0763 7.73025 20.0763 8.6255Z"
                fill="white"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.55143 0.983703H0V6.07913H5.55143V0.983703Z"
                fill="#D5AF33"
              />
              <path
                d="M237.793 24.3621V5.89418H243.365V24.3621H237.793Z"
                fill="#D5AF33"
              />
              <path
                d="M248.583 0.983703H261.378C263.738 0.983703 265.87 1.47153 267.817 2.43648C269.75 3.38533 271.3 4.75233 272.452 6.50799C273.604 8.26364 274.187 10.3195 274.187 12.6809C274.187 15.0424 273.604 17.0982 272.452 18.8539C271.3 20.5934 269.75 21.9604 267.817 22.9254C265.87 23.8903 263.738 24.3647 261.378 24.3647H248.583V0.983703ZM265.047 18.5215C266.14 17.9747 267.009 17.1974 267.648 16.2056C268.288 15.1978 268.614 14.0345 268.614 12.6809C268.614 11.3273 268.288 10.148 267.648 9.15621C267.007 8.14839 266.14 7.37107 265.047 6.82427C263.953 6.27747 262.729 5.99067 261.378 5.99067H254.156V19.3551H261.378C262.729 19.3551 263.953 19.0817 265.047 18.5215Z"
                fill="#D5AF33"
              />
              <path
                d="M279.402 0.983703H300V5.99067H284.975V10.1774H292.648V15.1844H284.975V19.3578H300V24.3647H279.402V0.983703Z"
                fill="#D5AF33"
              />
              <path
                d="M212.176 12.1663V24.3299H217.406V19.859L212.176 12.1663Z"
                fill="white"
              />
              <path
                d="M227.185 16.5112C230.31 15.1549 232.13 12.4799 232.13 8.82921C232.13 3.37193 228.112 0 221.689 0H209.262L216.848 9.98445V4.58883H221.382C224.783 4.58883 226.499 6.1515 226.499 8.82921C226.499 11.5069 224.783 13.0696 221.382 13.0696H218.895L226.602 24.3299H232.578L227.185 16.5085V16.5112Z"
                fill="#D5AF33"
              />
            </svg>
          </a>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
